import axios from 'axios';

export default {
  downloadReservationReport(params, filename){
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/api/latest/admin/reservations/reports";

    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           // console.log(response);
           link.setAttribute('download', filename); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },
  fetchProductsReservation (params) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/reservations/products", {params})
      .then(results=>{
        return results.data;
      })
  },
  downloadReservationExtraction(report,type, params) {
    params.reportType = type;
    params.report = report;
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/reservations/reports`;
    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           link.setAttribute('download', 'reservations.xlsx'); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },
  fetchReservationsV2(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/reservations", {params})
      .then(results=>{
        return results.data;
      })
  },
  // DEPRECATED use fetchReservationsV2 instead
  fetchReservations(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/reservations", {params})
      .then(results=>{
        return results.data;
      })
  },
  getReservation(reservationId){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/reservations/"+reservationId)
      .then(results=>{
        return results.data;
      })
  },
  postReservation(reservations){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/reservations", reservations)
      .then(results=>{
        return results.data;
      })
  },
  // DEPRECATED use validateV2 instead
  validate(reservation){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/reservations/validate", reservation)
      .then(results=>{
        return results.data;
      })
  },
  validateV2(reservation){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/reservations/validate", reservation)
      .then(results=>{
        return results.data;
      })
  },
  deleteReservation(reservationId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/reservations/"+reservationId);
  },
  putReservation(reservationToUpdate){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/reservations/"+reservationToUpdate.id, reservationToUpdate)
      .then(results=>{
        return results.data;
      })
  }
}
